// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-xs{padding:.5rem;font-size:75%;line-height:1;border-radius:1rem}@media print{.navbar{display:block}a:not(.btn){text-decoration:none}.badge{border:none}}.l-report #wrapper-inner{padding-left:0}.l-report .l-content{background-color:#fafafa}.l-report .l-section>.l-section-h{padding-top:1.5rem}.l-report .l-section:last-child>.l-section-h:last-child{padding-bottom:1.5rem}", ""]);
// Exports
module.exports = exports;
